import alt from '../components/alt';

class AppConfigActions {
  setConfig(config) {
    return config;
  }
}

export default alt.createActions(AppConfigActions);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/reverb-js-common/app_config_actions.js